<template>
  <div>
    <div
      style="
        display: flex;
        align-items: center;
        position: relative;
        justify-content: center;
      "
      class="mt-3"
    >
      <v-btn icon style="position: absolute; left: 10px" @click="$router.back()"
        ><v-icon>arrow_back</v-icon>
      </v-btn>
      <h2 class="text-xs-center">Review Benefit Log Table</h2>
    </div>

    <v-data-table
      :headers="headers"
      :items="logList"
      class="mt-4"
      style="border: 1px solid black"
      hide-actions
      :loading="isLoading"
    >
      <template v-slot:items="props">
        <tr>
          <td class="text-xs-center">
            {{ props.item.review_customer_full_name }}
          </td>
          <td class="text-xs-center">
            {{ props.item.review_order_code }}
          </td>
          <td class="text-xs-center">
            {{ moment(props.item.create_at).format("YYYY/MM/DD HH:mm:ss") }}
          </td>
          <td class="text-xs-center">
            {{ props.item.review_store_name }}
          </td>
          <td class="text-xs-center">
            {{ props.item.review_overall_rating }}
          </td>
          <td class="text-xs-center">
            {{ props.item.review_food_rating }}
          </td>
          <td class="text-xs-center">
            {{ props.item.review_atmosphere_rating }}
          </td>
          <td class="text-xs-center">
            {{ props.item.review_serves_rating }}
          </td>
          <td class="text-xs-center">
            {{ props.item.review_valuable_rating }}
          </td>
          <td class="text-xs-center">
            {{ props.item.review_text }}
          </td>
        </tr>
      </template>
    </v-data-table>
    <div></div>
    <div
      class="my-3"
      style="display: flex; align-items: center; justify-content: center"
    >
      <div
        style="
          width: 50vw;
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        <v-pagination
          class="mt-3"
          v-model="currentPage"
          :length="TotalPage"
          @input="getData()"
        ></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      headers: [
        {
          text: "Customer name",
          align: "center",
          sortable: false,
        },
        {
          text: "Order code",
          align: "center",
          sortable: false,
        },
        {
          text: "Review at",
          align: "center",
          sortable: false,
        },
        {
          text: "Store name",
          align: "center",
          sortable: false,
        },
        {
          text: "Overall review",
          align: "center",
          sortable: false,
        },
        {
          text: "Food rating",
          align: "center",
          sortable: false,
        },
        {
          text: "Atmosphere rating",
          align: "center",
          sortable: false,
        },
        {
          text: "Serve rating",
          align: "center",
          sortable: false,
        },
        {
          text: "Valuable rating",
          align: "center",
          sortable: false,
        },
        {
          text: "Message",
          align: "center",
          sortable: false,
        },
      ],
      logList: [],
      currentPage: 1,
      TotalPage: 0,
      pageSize: 20,
    };
  },
  methods: {
    ...mapActions({
      fetchCampaignUsedLog: "fetchDineIn/fetchCampaignUsedLog",
    }),
    async getData() {
      this.isLoading = true;
      let result = await this.fetchCampaignUsedLog({
        campaign_review_id: this.$route.params.campaign_review_id,
        page: this.currentPage,
        page_size: this.pageSize,
      });
      this.isLoading = false;
      this.TotalPage = result.page_total;
      this.logList = result.data;
      return;
    },
  },
  async created() {
    await this.getData();
  },
};
</script>

<style lang="scss" scoped></style>
